function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#a166ff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-VPN-Connection_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M40.38,48.5h-30a1,1,0,0,1-1-1V24.06a1,1,0,0,1,1-1h30a1,1,0,0,1,.71.3,1,1,0,0,1,.29.7V47.5A1,1,0,0,1,40.38,48.5Zm-29-2h28V25.07h-28Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M25.4,35.75h0a4.14,4.14,0,0,1,0-8.28h0a4.14,4.14,0,0,1,0,8.28Zm0-6.28a2.13,2.13,0,0,0-2.13,2.14,2.13,2.13,0,0,0,2.13,2.14h0a2.14,2.14,0,0,0,1.51-.62,2.17,2.17,0,0,0,.62-1.52h0a2.13,2.13,0,0,0-.62-1.51,2.16,2.16,0,0,0-1.52-.63Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 24.39,
  y: 34.87,
  width: 2,
  height: 6.32
}), React.createElement("rect", {
  className: "cls-2",
  x: 15.09,
  y: 18.44,
  width: 2,
  height: 5.63
}), React.createElement("rect", {
  className: "cls-2",
  x: 33.8,
  y: 18.44,
  width: 2,
  height: 5.63
}), React.createElement("path", {
  className: "cls-2",
  d: "M35.8,12.77h-2v-.32c0-4.92-3.71-8.93-8.3-8.95a8.66,8.66,0,0,0-8.41,8.86v.41h-2v-.42A10.66,10.66,0,0,1,25.46,1.5a10.66,10.66,0,0,1,10.34,11Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M41.16,21l-1.42-1.41,4-4-4.07-3.91L41,10.25l4.79,4.61a1,1,0,0,1,.31.71,1,1,0,0,1-.29.72Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 5.05,
  y: 14.65,
  width: 40.29,
  height: 2
}), React.createElement("path", {
  className: "cls-2",
  d: "M8.9,21,4.17,16.32a1,1,0,0,1,0-1.42L8.9,10.23l1.41,1.42-4,4,4,4Z"
}));

var SvgAwsVpnConnection = function SvgAwsVpnConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 60",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsVpnConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-VPN_Connection.1a341db8.svg";
export { ForwardRef as ReactComponent };